/**
 * Save OCR Responses to Intake Address Action
 *
 * Populates intake address fields from OCR-extracted data.
 * Uses shared mapAddressToResponses helper.
 */

import { assign } from "xstate";
import { mapAddressToResponses } from "../helper/address-response-mapper";
import type { ActionWithMetadata } from "./save-actor-result.action";

export const saveOCRresponsesToIntakeAddress: ActionWithMetadata = {
  // biome-ignore lint/suspicious/noExplicitAny: XState action params are complex
  impl: assign(({ context }: any) => {
    // Skip OCR pre-fill for minors — the ID belongs to the guardian, not the patient
    if (context.under18) {
      return {};
    }

    const ocrData = context.ocrData;
    if (!ocrData || typeof ocrData !== "object") {
      return {};
    }

    return {
      responses: mapAddressToResponses(
        context.intakeFormSections,
        context.responses || {},
        {
          street: ocrData?.address?.street,
          city: ocrData?.address?.city,
          state: ocrData?.address?.state,
          zip: ocrData?.address?.zipCode,
        },
      ),
    };
  }),
  metadata: {
    displayName: "saveOCRresponsesToIntakeAddress",
    description: "Save OCR-extracted address data to intake address fields",
    category: "context",
  },
};
